"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../../Constant");

var _Typography = require("../../Typography");

var _Flex = require("../../../Layout/Flex");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 0;\n  margin-top: 0;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  height: 75px;\n  border-top: solid 1px ", ";\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Footer = (0, _styledComponents.default)(_Flex.FlexContainer)(_templateObject(), _Constant.Color.GREY_3);
var Message = (0, _styledComponents.default)(_Typography.Typography.FieldBody)(_templateObject2(), function (_ref) {
  var color = _ref.color;
  return color;
});

var NoItemsFooter = function NoItemsFooter(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_react.default.createElement(Footer, null, /*#__PURE__*/_react.default.createElement(Message, {
    color: _Constant.Color.BLACK_SOUL
  }, children));
};

NoItemsFooter.propTypes = {
  children: _propTypes.default.string
};
NoItemsFooter.defaultProps = {
  children: ''
};
var _default = NoItemsFooter;
exports.default = _default;